import { type Config, config } from '#@/platform/networking/client/lib/config'

export function setClientConfig(init: Init) {
  Object.assign(config, init, {
    initialized: true,
  })
}

// All fields are optional so consumers can layer partial updates (e.g. a web init
// followed by an app-specific customFetch override).
type Init = Partial<Omit<Config, 'initialized'>>
